import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
    getLabSpecimenSuccess, getLabSpecimenFailure,
    getLabSpecimenByAccessionSuccess, getLabSpecimenByAccessionFailure,
    collectLabSpecimenSuccess, collectLabSpecimenFailure,
    receiveLabSpecimenSuccess, receiveLabSpecimenFailure,
    rejectLabSpecimenSuccess, rejectLabSpecimenFailure,
    updateStorageLabSpecimenSuccess, updateStorageLabSpecimenFailure,
    disposeLabSpecimenSuccess, disposeLabSpecimenFailure,
    bulkReceiveLabSpecimenSuccess, bulkReceiveLabSpecimenFailure,
} from './slice';
import requestHandler from '../../../../utils/requestHandler';
import { logoutRequest } from '../../auth/authSlice';

function* getRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const { page, limit, searchQuery, status } = action.payload || {};
        const currentBranch = yield select(state => state.branch.currentBranch);
        let url = `${process.env.REACT_APP_SERVER_API}api/laboratory/specimens?page=${page || 1}&limit=${limit || 10}&searchQuery=${encodeURIComponent(searchQuery || '')}`;
        if (status) url += `&status=${encodeURIComponent(status)}`;
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id }
        };
        const response = yield call(requestHandler, url, requestDetail);
        yield put(getLabSpecimenSuccess(response));
    } catch (error) { yield put(getLabSpecimenFailure(error?.response?.message || error)); }
}

function* getByAccessionRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/specimens/accession/${action.payload}`, requestDetail);
        yield put(getLabSpecimenByAccessionSuccess(response));
    } catch (error) { yield put(getLabSpecimenByAccessionFailure(error?.response?.message || error)); }
}

function* collectRequest(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "POST",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json", "X-Current-Branch": currentBranch.id },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/specimens/collect`, requestDetail);
        yield put(collectLabSpecimenSuccess(response));
    } catch (error) { yield put(collectLabSpecimenFailure(error?.response?.message || error)); }
}

function* receiveRequest(action) {
    try {
        const { id, conditionOnReceipt } = action.payload;
        const requestDetail = {
            method: "PUT",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify({ conditionOnReceipt })
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/specimens/${id}/receive`, requestDetail);
        yield put(receiveLabSpecimenSuccess(response));
    } catch (error) { yield put(receiveLabSpecimenFailure(error?.response?.message || error)); }
}

function* rejectRequest(action) {
    try {
        const { id, reason, notes, recollectionRequired } = action.payload;
        const requestDetail = {
            method: "PUT",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify({ reason, notes, recollectionRequired })
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/specimens/${id}/reject`, requestDetail);
        yield put(rejectLabSpecimenSuccess(response));
    } catch (error) { yield put(rejectLabSpecimenFailure(error?.response?.message || error)); }
}

function* updateStorageRequest(action) {
    try {
        const { id, storageLocation } = action.payload;
        const requestDetail = {
            method: "PUT",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify({ storageLocation })
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/specimens/${id}/storage`, requestDetail);
        yield put(updateStorageLabSpecimenSuccess(response));
    } catch (error) { yield put(updateStorageLabSpecimenFailure(error?.response?.message || error)); }
}

function* disposeRequest(action) {
    try {
        const { id, reason } = action.payload;
        const requestDetail = {
            method: "PUT",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json" },
            body: JSON.stringify({ reason })
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/specimens/${id}/dispose`, requestDetail);
        yield put(disposeLabSpecimenSuccess(response));
    } catch (error) { yield put(disposeLabSpecimenFailure(error?.response?.message || error)); }
}

function* bulkReceiveRequest(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "PUT",
            headers: { "Authorization": localStorage.getItem("item"), "Content-Type": "application/json", "X-Current-Branch": currentBranch.id },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/specimens/bulk-receive`, requestDetail);
        yield put(bulkReceiveLabSpecimenSuccess(response));
    } catch (error) { yield put(bulkReceiveLabSpecimenFailure(error?.response?.message || error)); }
}

function* saga() {
    yield takeLatest('labSpecimen/getLabSpecimenRequest', getRequest);
    yield takeLatest('labSpecimen/getLabSpecimenByAccessionRequest', getByAccessionRequest);
    yield takeLatest('labSpecimen/collectLabSpecimenRequest', collectRequest);
    yield takeLatest('labSpecimen/receiveLabSpecimenRequest', receiveRequest);
    yield takeLatest('labSpecimen/rejectLabSpecimenRequest', rejectRequest);
    yield takeLatest('labSpecimen/updateStorageLabSpecimenRequest', updateStorageRequest);
    yield takeLatest('labSpecimen/disposeLabSpecimenRequest', disposeRequest);
    yield takeLatest('labSpecimen/bulkReceiveLabSpecimenRequest', bulkReceiveRequest);
}

export default saga;
